<template>
	<div class="textarea-component">
		<label v-if="label">{{ label }}</label>
		<b-form-textarea
			:value="value"
			placeholder="Enter"
			:rows="rows"
			:max-rows="maxRows"
			no-resize
			:class="{ error: validation }"
			@input="$emit('input', $event)"
			:disabled="disabled"
		></b-form-textarea>
		<div
			style="position: absolute; top: 18px;
    right: 6px; z-index: 1000"
			v-if="validation"
			v-b-popover.hover.top.v-danger="{ content: validationMessage }"
			variant="primary"
		>
			<img src="../../assets/deletepopupicon.svg" alt="" />
		</div>
	</div>
</template>

<script>
export default {
	name: "TextAreaComponent",
	props: {
		value: {
			type: String,
			default: "",
		},
		rows: {
			type: Number,
			default: 3,
		},
		maxRows: {
			type: Number,
			default: 6,
		},
		label: {
			type: String,
			default: "",
		},
		validation: {
			type: Boolean,
			default: false,
		},
		validationMessage: {
			type: String,
			default: "Required",
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
};
</script>
<style>
.textarea-component .form-control:disabled{
	background-color: #f7f7f7;
}
</style>